export default __webpack_public_path__ + "c7c8040aa957237e954309fd0ed8e28b.png";